/**
* BaseController
* @namespace gplans.layout.controllers
*/
(function () {
  'use strict';BaseController.$inject = ["$interval", "$rootScope", "$scope", "$state", "$cookies", "$window", "DateTime", "Intercom", "Profile", "User", "Funnel", "UserService"];

  angular.
  module('gplans.layout.controllers').
  controller('BaseController', BaseController);

  BaseController.$inject = [
  '$interval',
  '$rootScope',
  '$scope',
  '$state',
  '$cookies',
  '$window',
  'DateTime',
  'Intercom',
  'Profile',
  'User',
  'Funnel',
  'UserService'];


  /**
                  * @namespace BaseController
                  */
  function BaseController(
  $interval,
  $rootScope,
  $scope,
  $state,
  $cookies,
  $window,
  DateTime,
  Intercom,
  Profile,
  User,
  Funnel,
  UserService)
  {
    var stop;
    var midnight = DateTime.now();

    activate();

    function activate() {
      var step = Funnel.getStep();
      Funnel.redirect(step);

      $rootScope.pageTitle = $state.current.title;
      $rootScope.pageDescription = $state.current.description;

      $rootScope.now = DateTime.now();
      $rootScope.nextWeek = DateTime.now();
      $rootScope.nextWeek.setDate($rootScope.nextWeek.getDate() + 7);

      $rootScope.membershipsAvailable = false;

      // midnight.setHours(24,0,0,0); // real midnight
      midnight.setHours(midnight.getHours(), midnight.getMinutes() + 43, 0, 0); // now + 1h
      setTimeToMidnight();
      stop = $interval(function () {
        setTimeToMidnight();
      }, 1000);

      // $rootScope.$watch(function () {return UserService.data;}, handleUserCheked);
      //
      // function handleUserCheked(newVal, oldVal) {
      //   if (!UserService.data.id) {
      //     if($state.current.authenticated) $state.go('login');
      //   } else {
      //     // Intercom.bootOrUpdate(UserService.data); // we boot on all pages!
      //   }
      // }

      function setTimeToMidnight() {
        var now = DateTime.now();
        var diff = midnight - now;
        if (diff >= 0) {
          var seconds = ('0' + Math.floor(diff / 1000 % 60)).slice(-2);
          var minutes = ('0' + Math.floor(diff / 1000 / 60 % 60)).slice(-2);
          var hours = ('0' + Math.floor(diff / (1000 * 60 * 60) % 24)).slice(-2);
          $rootScope.timeToMidnight = hours + 'h ' + minutes + 'min ' + seconds + 'sec'; // 20h 30min 03sec

          if (!$rootScope.membershipsAvailable) {
            $rootScope.membershipsAvailable = Math.floor((98 - 5) * (diff / 1000 / 86400)) + 5;
          }
        }
      }
    }

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      if (UserService.data.id) {
        Profile.updateMisc({
          key: 'lastViewedPage',
          value: JSON.stringify({
            state: toState.name,
            params: toParams }) }).

        then(function (res) {
          // console.log(res);
        }, function () {
          Profile.createMisc({
            key: 'lastViewedPage',
            value: JSON.stringify({
              state: toState.name,
              params: toParams }) });


        });
      }
    });

    $scope.$on("$destroy", function () {
      if (stop) {
        $interval.cancel(stop);
      }
    });
  }
})();